import React from "react";

import { getNumberDayMonthYear } from "~/libs/getDateOptions";

import SrrRowBase from "./SrrRowBase";

const ReportNSByWarmClients = ({ row, items }) => {
  const renderItem = [
    row.dealer.DealerName,
    row.dealer.city,
    row.dealer.INN,
    row.dealer.ent_id,
    row.dealer.entfCode,
    row.dealer.subject,
    row.dealer.FO,
    row.dealer.status === "active" ? "1" : "0",
    row.vin,
    row.client.name,
    row.goldenId,
    row.client.phone,
    row.client.email,
    getNumberDayMonthYear({ date: row.soldDate }),
    getNumberDayMonthYear({ date: row.creditDate }),
    getNumberDayMonthYear({ date: row.creditEndDate }),
    getNumberDayMonthYear({ date: row.warrantyEndDate }),
    row.ePlatformDate ? getNumberDayMonthYear({ date: row.ePlatformDate }) : "",
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByWarmClients;
